import * as angular from 'angular';

function sticky($window: ng.IWindowService) {
    return {
        restrict: 'A',
        link: function (scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, ctrl: ng.IController) {
            const height: number = element.offset().top;
            let stickyClass: string = attrs.stickyClass;
            let window = angular.element($window);

            window.bind('scroll', function () {
               let scrollY = (<any>window[0]).pageYOffset;
               scrollY > height ? element.addClass(stickyClass) : element.removeClass(stickyClass);
            });
        }
    };
}

angular
    .module('naut')
    .directive('sticky', sticky);

sticky.$inject = ['$window'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/sticky/sticky.directive.ts